"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var getStyle = function () {
    return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    };
};
var DefaultFormatter = /** @class */ (function (_super) {
    tslib_1.__extends(DefaultFormatter, _super);
    function DefaultFormatter(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseOver = function (e) {
            _this.setTitle(e.currentTarget);
        };
        _this.state = { title: undefined };
        return _this;
    }
    DefaultFormatter.prototype.setTitle = function (currElem) {
        if (typeof this.props.value === 'string') {
            var title = void 0;
            if (currElem.offsetWidth < currElem.scrollWidth) {
                title = this.props.value;
            }
            this.setState({ title: title });
        }
    };
    DefaultFormatter.prototype.render = function () {
        var style = getStyle();
        var props = {
            style: style,
            title: this.state.title,
            onMouseOver: this.onMouseOver,
            'data-tb-test-id': this.props.testId
        };
        return (React.createElement("div", tslib_1.__assign({}, props), this.props.value));
    };
    return DefaultFormatter;
}(React.Component));
exports.DefaultFormatter = DefaultFormatter;
//# sourceMappingURL=DefaultFormatter.js.map